<div class="setting-page">
  <legend>Azure Authentication</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit">
    <div class="azure-authentication-settings">

      <div class="left-side">
        <arm-form-title>Azure Active Directory Authentication</arm-form-title>
        <div class="settings-section">
          <mat-slide-toggle color="primary"
                            [checked]="azureAuthentication.enabled"
                            (change)="azureAuthentication.enabled = $event.checked">
            Enable Azure Authentication
          </mat-slide-toggle>

          <mat-form-field class="fullWidth">
            <mat-label>Azure Tenant Id</mat-label>
            <input [(ngModel)]="azureAuthentication.tenantId" matInput name="tenant" [required]="azureAuthentication.enabled">
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>Azure Client Id</mat-label>
            <input [(ngModel)]="azureAuthentication.clientId" matInput name="client-id" [required]="azureAuthentication.enabled">
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>Azure Client Secret</mat-label>
            <input autocomplete="new-password" type="password" [(ngModel)]="azureAuthentication.clientSecret" matInput name="client-secret">
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>Azure Redirect URL</mat-label>
            <input disabled [(ngModel)]="azureAuthentication.redirectUrl" matInput name="redirect-uri">
            <button type="button" mat-button matSuffix mat-icon-button
                    #tooltip="matTooltip"
                    [cdkCopyToClipboard]="azureAuthentication.redirectUrl"
                    (mouseenter)="mouseEnterCopyToClipboard()"
                    (click)="copyMachineIdToClipboard()"
                    matTooltip="Copy to clipboard"
                    matTooltipPosition="right">
              <mat-icon class="clear-button">file_copy</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
      <div class="right-side">
      </div>
    </div>

    <div class="azure-test-connectivity-button-container">
      <ac-button  (click)="testServerConnectivity()"
              [ngDisabled]="!azureAuthentication.tenantId || !azureAuthentication.clientId">Test</ac-button>
    </div>

    <div class="azure-server-test-connectivity-result-wrapper"
         [ngClass]="{'green': testResult === 'Azure AD connection test successful'}">
      <mat-label class="azure-server-test-connectivity-result">{{testResult}}</mat-label>
    </div>

  </arm-form>
</div>
